import React from "react";
import { latestOffer } from "../../fourthUtils/constant";

const LatestOffers = (props) => {
    const { language } = props
    const isELSelect = language?.language === 'english'
    const isAlSelect = language?.language === 'arabic'
    return (
        <div className="latest-offer-main">
            {
                latestOffer?.map((v, i) => {
                    return (
                        <div>
                            <img src={v?.img} alt="" />
                            <p>
                                {isELSelect ? v?.title : (isAlSelect ? v?.alTitle : v?.glTitle)}
                            </p>
                        </div>
                    )
                })
            }
        </div>
    )
}
export default LatestOffers